export const PERIOD_MONTH = 'month'
export const PERIOD_YEAR = 'year'
